import React, { Component } from 'react'
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import Formsy from 'formsy-react'
import { Grid, Dimmer, Loader } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addValidationRule } from 'formsy-react';
import queryString from 'query-string';
import GeneralError from 'components/GeneralError/GeneralError'
import { setAuthState, setSearchFormVisibilityInHeader } from '../../store/actions/actions';
import { login, validateManagerAuthorization } from '../../services/User';
import appleIcon from '../../assets/images/newui/apple.png'
import fieldEmailIcon from '../../assets/images/newui/field-email-icon.png'
import fieldPasswordIcon from '../../assets/images/newui/field-password-icon.png'
import { NavigationUrls } from '../../constants/NavigationUrls'
import './SignInContainerNew.less'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';

const initialState = {
    loading: false,
    email: '',
    password: '',
    errorMsg: '',
    windowWidth: 0,
}

function isNotBlankString(values, value) {
    return value && value.trim().length > 0;
}

addValidationRule('isNotBlankString', isNotBlankString);

function SignInContainerNewWrapper (props) {
    const history = useNavigate();
    const location = useLocation();

    return( 
        <>
            <SignInContainerNew {...props} history={history} location={location} />
        </> 
        )
}

class SignInContainerNew extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
        //pageView('/signin', 'Login');
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.props.setSearchFormVisibilityInHeader(true);
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    handlePhoneChange = (e, { value }) => {
        this.setState({ cellnumber: format(value) });
    }


    onValidSigninSubmit = async () => {
        try {
            const { email, password } = this.state;
            this.setState({ isLoading: true });
            const response = await login(email, password);
            if (response.resStatus >= 400) {
                this.setState({ errorMsg: response.message || 'Error while login.' })
            }
            if (response.resStatus == 200) {
                const authRes = await validateManagerAuthorization();
                if (authRes.resStatus >= 400) {
                    this.setState({ errorMsg: authRes.message || 'Error while login.' })
                }
                else if (authRes.resStatus == 200){
                    
                    const queryParams = queryString.parse(this.props.location.search);
                    let redirectTo;
                    if(queryParams.originalUrl && queryParams.originalUrl != "undefined")
                    {
                        redirectTo = queryParams.originalUrl;
                    }else
                    {
                        redirectTo = `${NavigationUrls.REQUESTS_URL}`;
                    }
                    this.props.setAuthState(true, authRes.data.user, '');
                    this.props.history(redirectTo);
                }
                //logBuyerSignIn(response.data.user);
            }
        } catch (error) {
            this.setState({ loading: false });

        } finally {
            this.setState({ loading: false });
        }
    };

    redirectToAppStore = () => {
        window.open('http://itunes.apple.com/app/id1481417514', '_blank');
    }

    redirectToSignUp = () => {
        this.props.history('/signup');
    }

    render() {
        return (
            <div className="main-slide">
                <div className="signin-box">
                    {this.state.windowWidth >= 1024 && <div className="left-pane">
                        <div className="top-part">
                            <div className="heading">
                            </div>
                            <div className="thank-you">
                                Login to your <br />
                                <span className="emphasize">Dealgrace</span> Account
                            </div>
                            <div className="description">
                                Let us do the work for you
                            </div>
                        </div>
                        <div className="bottom-part">
                            <div>
                                <span>Access Dealgrace</span><br />
                                <span>anytime, anywhere</span>
                            </div>
                            <div onClick={this.redirectToAppStore}>

                                <div><img src={appleIcon}></img></div>
                                <div>
                                    <div>Download on the</div>
                                    <div>App Store</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <Dimmer.Dimmable as="div" dimmed={this.state.loading} className="right-pane">
                        <Dimmer active={this.state.loading}>
                            <Loader size="big">Loading</Loader>
                        </Dimmer>
                        <div className="sign-in-container">
                            <div className="header">
                                <div className="heading">
                                    Login
                                </div>
                                <div className="subheading">

                                </div>
                            </div>
                            <div className="sign-in-form">
                                <Formsy onValidSubmit={this.onValidSigninSubmit} noValidate>
                                    <Grid>
                                        <Grid.Column mobile={16} tablet={16} computer={16}>
                                            <DGTextbox name="email" label="Email" placeholder="Ex: example@email.com" required type="email"
                                                tabIndex={3}
                                                icon={fieldEmailIcon}
                                                maxLength={100}
                                                validations={{
                                                    isEmail: true,
                                                    maxLength: 100
                                                }}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                    maxLength: 'Email should not exceed 100 characters.',
                                                    isEmail: 'Enter a valid email.'
                                                }}
                                                onChange={this.handleChange}
                                            />
                                        </Grid.Column>
                                        <Grid.Column mobile={16} tablet={16} computer={16}>
                                            <DGTextbox name="password" label="Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={100}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                }}
                                                onChange={this.handleChange}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                    <div className="disclaimer">
                                        <div className="link"
                                            onClick={() => this.props.history(
                                                '/reset-password-request'
                                            )}>Forgot Password?</div>
                                    </div>
                                    {this.state.errorMsg && !_.isEmpty(this.state.errorMsg) &&
                                        <GeneralError message={this.state.errorMsg} />
                                    }
                                    <div className="submit-form-button">
                                        <button type="submit" className="button-submit">LOGIN</button>
                                    </div>
                                </Formsy>
                            </div>
                            {/* <div className="separator">
                                <div className="left">
                                    <img src={separator}></img>
                                </div>
                                <div className="or">
                                    OR
                                </div>
                                <div className="right">
                                    <img src={separator}></img>
                                </div>
                            </div>
                            <div className="switch">
                                New to Dealgrace? <div className="link" onClick={this.redirectToSignUp}>SIGN UP</div>
                            </div> */}
                        </div>
                    </Dimmer.Dimmable>
                </div>
            </div>
        )
    }
}

function mapStateToProps({ buyer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        buyerFormData: buyer
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState: setAuthState,
        setSearchFormVisibilityInHeader
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInContainerNewWrapper);

